import { TFunction } from "i18next";
import { z } from "zod";

export const getManagementUnitFormSchema = (t: TFunction) => {
  return z.object({
    name: z.string().min(1, { message: t("entities.entity.management-units.errors.name-required") }),
    unitTypeId: z
      .number({
        required_error: t("entities.entity.management-units.errors.unit-type-required"),
        invalid_type_error: t("entities.entity.management-units.errors.unit-type-required"),
      }),
    notes: z.string().nullable().optional(),
  });
};

export type ManagementUnitForm = z.infer<ReturnType<typeof getManagementUnitFormSchema>>;
